import { NotificationManager, PaymentV2Api } from '@atlas/core';

export const getPixCodeFromPaymentData = (data, fallbackValues = {}) => {
  const additionalParams = data?.formData?.additionalParams ?? {};

  return (
    data?.redirectUrl ||
    additionalParams.externalURL ||
    additionalParams.externalUrl ||
    fallbackValues.externalURL ||
    fallbackValues.externalUrl ||
    fallbackValues.redirectUrl
  );
};

export const shouldCreateNewDeposit = (createTime, expirationCountdown, ttlInSeconds) => {
  const hasRequiredTimeData = [createTime, expirationCountdown, ttlInSeconds].every(Number.isFinite);

  if (!hasRequiredTimeData) return true;

  const elapsedTime = Date.now() - createTime;
  return elapsedTime + expirationCountdown * 1000 >= ttlInSeconds * 1000;
};

export const generateNewPixCode = async ({
  amount,
  createTime,
  expirationCountdown,
  formId,
  id,
  interpolationValues,
  paymentMethod,
  paymentOptions,
  publicPaymentId,
}) => {
  let newData;

  if (
    shouldCreateNewDeposit(createTime, expirationCountdown, paymentMethod.transactionTtlInSeconds)
  ) {
    const response = await PaymentV2Api.createAsyncDeposit({
      ...paymentOptions,
      amount,
      pmId: String(paymentMethod.id),
    });
    newData = await PaymentV2Api.getPaymentStatus(response.publicPaymentId);
  } else {
    newData = await PaymentV2Api.getPaymentStatus(publicPaymentId);
  }

  const nextInterpolationValues = newData.formData?.additionalParams ?? interpolationValues;
  const nextPixCode = getPixCodeFromPaymentData(newData, nextInterpolationValues);

  NotificationManager.removeNotification(id);
  NotificationManager.display({
    data: {
      amount,
      createTime: newData.createTime,
      formId,
      interpolationValues: nextInterpolationValues,
      paymentMethod,
      ...(paymentOptions && { paymentOptions }),
      pixCode: nextPixCode,
      publicPaymentId: newData.publicPaymentId ?? publicPaymentId,
    },
    type: 'pixDepositResult',
  });
};
